import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { Button } from "@material-ui/core";

import { FormLabel } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { FormContext } from "../../util/context";

const SleepPerNight = () => {
  const [form, setForm] = useContext(FormContext);
  return (
    <>
      <Container maxWidth="sm">
        <Typography align="center" variant="h4">
          How many hours of sleep do you usually get?
        </Typography>
      </Container>
      <Box mt={5}>
        <FormLabel id="select">
          <Typography variant="h6">Hours of Sleep per Night</Typography>
        </FormLabel>
        <TextField
          fullWidth
          variant="outlined"
          id="select"
          select
          defaultValue={form.hoursSleep}
          onChange={(event) => {
            setForm({
              ...form,
              hoursSleep: event.target.value,
            });
          }}
        >
          <MenuItem value={1}>1</MenuItem>
          <MenuItem value={2}>2</MenuItem>
          <MenuItem value={3}>3</MenuItem>
          <MenuItem value={4}>4</MenuItem>
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={6}>6</MenuItem>
          <MenuItem value={7}>7</MenuItem>
          <MenuItem value={8}>8</MenuItem>
          <MenuItem value={9}>9</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={11}>11</MenuItem>
          <MenuItem value={12}>12+</MenuItem>
        </TextField>
      </Box>
      <Box mt={2}>
        <Button
          variant="contained"
          fullWidth
          color="primary"
          onClick={() =>
            setForm({
              ...form,
              count: form.count + 1,
            })
          }
        >
          Next
        </Button>
      </Box>
    </>
  );
};

export default SleepPerNight;
